module.exports = __webpack_public_path__ + "img/hong_kong.2b1822fe.png";